// @ts-nocheck
import GridLine from 'business/GridLine';
import {
  Point,
  RandomWellMap,
  TargetLayer,
  TargetLayerIngredient,
} from 'business/models/CustomModels';
import { DrawingLayer } from 'business/models/DrawingLayer';
import ExperimentDtoClient from 'business/models/ExperimentDtoClient';
import cloneDeep from 'lodash/cloneDeep';
import {
  DropDTO,
  LayerDTO,
  RandomLayerDTO,
  RandomLayerExcludeListDTO,
  RandomLayerGenerationListDTO,
  RandomLayerGroupIngredientDTO,
  RandomLayerIngredientGroupDTO,
  WellIngDTO,
  WellLayerDTO,
} from 'business/models/Models';
import RandomIngredientPicker from 'business/RandomIngredientPicker';
import {
  LayerType,
  isNullOrUndefined,
  getIngredientColor,
  getIngredientStock,
  GetWellRowNumber,
  getIngredientTypeColor,
} from 'utils/Global';
import { getUniqueLayerName } from '../GenerateUtil';
import RandomLayerGenerationList from '../RandomLayer/RandomLayerGenerationList';
import RandomLayerGroupIngredient from '../RandomLayer/RandomLayerGroupIngredient';
import RandomExcludeList from '../RandomLayer/RandomLayerExcludeList';
import {
  CreateTargetLayerIngredient,
  findWellsInLayer,
  getIngStock,
  updateWellByTargetLayer,
  createTargetLayer,
  getIngredient,
  IsBuffer,
  getIngIngType,
  getIngredientType,
  getWellById,
  RemoveWellIngredientsForOverrideLayer,
  copyWelllayerIngredients,
  findWellLayersInLayer1d,
  updateDropByTargetLayer,
  getDrop,
  newDrop,
  findWellDropsInLayer1d,
  unGenerateLayer,
  spliceArrayElement,
} from './GenerateCommon';
import { Compute } from './VolCalculator';

const MAX_WELL_INGREDIENT_GENERATION_ATTEMPTS = 100;
const MAX_GROUP_GENERATION_ATTEMPTS = 50;
export function Generate(docData: ExperimentDtoClient, lyr: DrawingLayer) {
  let randomLayer: RandomLayerDTO;
  if (lyr.type != LayerType.Random) {
    return;
  } else {
    randomLayer = lyr.layerDetail as RandomLayerDTO;
  }

  const wells = findWellsInLayer(
    docData.plateDto,
    lyr,
    docData.containerRows,
    docData.containerCols,
  );
  unGenerateLayer(docData, lyr);
  const wellIngredientsHash = [];
  let iter = 0;
  for (let i = 0; i < lyr.height + 1; i++) {
    for (let j = 0; j < lyr.width + 1; j++) {
      RemoveWellIngredientsForOverrideLayer(docData, lyr, wells[i][j]);
      const isGenerated = GenerateWellLayerIngredients(
        randomLayer,
        wells[i][j],
        wellIngredientsHash,
        lyr,
        docData,
      );
      const plate = docData.plateDto.find((p) =>
        p.ingredients.wellList.find((w) => w.wellId === wells[i][j].wellId),
      );
      if (!isGenerated) {
        plate.hasWarning = true;
        const warningMessage = plate.ingredients.warning
          ? plate.ingredients.warning
          : '' +
            'Layer have been generated for this experiment. However, due to the low number of possible conditions, not all specified wells are being used.';
        plate.ingredients.hasWarning = true;
        plate.ingredients.warning = warningMessage;
        wells[i][j].hasWarning = true;
        wells[i][j].warning = warningMessage;
        return !isGenerated || iter;
      } else {
        wells[i][j].hasWarning = false;
        wells[i][j].warning = '';
        plate.hasWarning = false;
        plate.ingredients.hasWarning = false;
        plate.ingredients.warning = '';
      }
      iter++;
    }
  }
}
function MapWells(docData: ExperimentDtoClient, wellMap: RandomWellMap[]) {
  const wells: WellIngDTO[][] = Array.from(
    Array(docData.containerRows * docData.rowCount),
    () => new Array(docData.containerCols * docData.colCount),
  );

  for (const plateRow of docData.plateDto) {
    for (const wellRow of plateRow.ingredients.wellList) {
      const row = parseInt(
        (
          GetWellRowNumber(wellRow, docData.containerCols) +
          (plateRow.rowPos - 1) * docData.containerRows
        ).toString(),
      );
      const col = parseInt(
        (wellRow.columnNumber + (plateRow.colPos - 1) * docData.containerCols).toString(),
      );
      wellMap.push({
        wellId: wellRow.wellId,
        wellPosition: new Point(col - 1, row - 1),
      });
      wells[row - 1][col - 1] = wellRow;
    }
  }
  return wells;
}
function GetSequencedWellLayerRows(docData: ExperimentDtoClient, lyr: LayerDTO) {
  const sequencedWellLayers: WellLayerDTO[] = [];
  let sequencedWellIDs: number[] = [];

  const wellMap: RandomWellMap[] = [];
  const wellMapArray: WellIngDTO[][] = MapWells(docData, wellMap);
  let startingWell: WellIngDTO = null;
  const wellLayers = findWellLayersInLayer1d(docData.plateDto, lyr);

  if (wellLayers.length == 0) {
    return sequencedWellLayers;
  }
  for (const wellLayerRow of wellLayers) {
    const well = getWellById(wellLayerRow.wellId, docData);
    if (well == null) {
      // in case of layer copy and experiment copy we will just have WellLayers and there ingredients and no Well Rows
      sequencedWellLayers.push(wellLayerRow);
      continue;
    }
    // in all other cases like move layer, Copy Experiment, Convert to Screen/Experiment we have well rows already
    if (startingWell == null) {
      startingWell = well;
    } else {
      startingWell = GetStartingWell(wellMap, startingWell, well);
    }
  }
  if (sequencedWellLayers.length > 0) {
    return sequencedWellLayers;
  }

  sequencedWellIDs = GetSequencedWellIds(wellMap, wellMapArray, lyr, startingWell);

  for (const wellID of sequencedWellIDs) {
    const well = getWellById(wellID, docData);
    const wellLayerRows: WellLayerDTO[] = well.wellLayerList.filter(
      (wll) => wll.layerId === lyr.id,
    );

    if (wellLayerRows.length > 0) {
      // TODO pushing list into list when both are same types
      sequencedWellLayers.push(cloneDeep(...wellLayerRows));
    }
    well.wellLayerList.splice(
      well.wellLayerList.findIndex(function (i) {
        return i.id === lyr.id;
      }),
      1,
    );
  }
  return sequencedWellLayers;
}
function GetSequencedWellIds(
  wellMap: any[],
  wellMapArray: WellIngDTO[][],
  lyr: LayerDTO,
  startingWell: WellIngDTO,
) {
  const sequencedWellIDs: number[] = [];
  const startingPoint: Point = wellMap.find(
    (wm) => wm.wellId === startingWell.wellId,
  ).wellPosition;
  for (let i = startingPoint.Y; i <= lyr.height + startingPoint.Y; i++) {
    for (let j = startingPoint.X; j <= lyr.width + startingPoint.X; j++) {
      sequencedWellIDs.push(wellMapArray[i][j].wellId);
    }
  }
  return sequencedWellIDs;
}
function GetStartingWell(wellMap: any[], firstWell: WellIngDTO, secondWell: WellIngDTO) {
  let startingWell = firstWell;
  const point1: Point = wellMap.find((wm) => wm.wellId === firstWell.wellId).wellPosition;
  const point2: Point = wellMap.find(
    (wm) => wm.wellId === secondWell.wellId,
  ).wellPosition;
  if (point1.Y > point2.Y || (point1.Y == point2.Y && point2.X < point1.X)) {
    startingWell = secondWell;
  }
  return startingWell;
}
function GenerateLockedWellLayers(docData: ExperimentDtoClient, lyr: DrawingLayer) {
  let randomLayer: RandomLayerDTO;
  if (lyr.type != LayerType.Random) {
    return randomLayer;
  } else {
    randomLayer = lyr.layerDetail as RandomLayerDTO;
  }

  const listWellLayerRows: WellLayerDTO[] = cloneDeep(
    GetSequencedWellLayerRows(docData, lyr),
  );
  unGenerateLayer(docData, lyr);
  let ableToGenerateAllWells = true;
  const wells = findWellsInLayer(
    docData.plateDto,
    lyr,
    docData.containerRows,
    docData.containerCols,
  );
  let count = 0;
  for (let i = 0; i < lyr.height + 1; i++) {
    for (let j = 0; j < lyr.width + 1; j++) {
      if (count >= listWellLayerRows.length) {
        break;
      }
      RemoveWellIngredientsForOverrideLayer(docData, lyr, wells[i][j]);
      ableToGenerateAllWells = GenerateWellForLockedLayer(
        docData,
        lyr,
        wells[i][j],
        listWellLayerRows[count],
      );
      count++;
      if (!ableToGenerateAllWells) {
        return false;
      }
    }
  }
  return true;
}
function GenerateWellDropForLockedLayer(
  docData: ExperimentDtoClient,
  lyr: DrawingLayer,
  targetWell: WellIngDTO,
  sourceDrop: DropDTO,
) {
  const targetLayer: TargetLayer = CopyWellDropLayer(lyr, sourceDrop);

  if (targetWell.wellLayerList.length === 0) {
    targetWell.wellLayerList = [];
  }
  Compute(targetLayer, lyr, docData);
  if (isNullOrUndefined(targetLayer)) {
    return;
  }
  const drop = updateDropByTargetLayer(lyr, targetLayer, targetWell);
  if (drop) {
    drop.volume += targetLayer.volume;
    drop.waterVolume += targetLayer.waterVolume;
  }

  return true;
}
function GenerateWellForLockedLayer(
  docData: ExperimentDtoClient,
  lyr: DrawingLayer,
  wellRow: WellIngDTO,
  wellLayerRow: WellLayerDTO,
) {
  const targetLayer: TargetLayer = CopyWellLayer(lyr, wellLayerRow);
  Compute(targetLayer, lyr, docData);
  if (isNullOrUndefined(targetLayer)) {
    return;
  }
  updateWellByTargetLayer(lyr, targetLayer, wellRow);
  wellLayerRow = null;
  return true;
}
function CopyWellLayer(lyr: DrawingLayer, sourceWellLayerRow: WellLayerDTO) {
  const targetWellLayerRow: TargetLayer = new TargetLayer();

  targetWellLayerRow.sourceWellConditionNumber =
    sourceWellLayerRow.sourceWellConditionNumber;
  targetWellLayerRow.sourceWellId = sourceWellLayerRow.wellId;

  targetWellLayerRow.layerId = lyr.id;

  targetWellLayerRow.volume = sourceWellLayerRow.volume;

  targetWellLayerRow.waterVolume = sourceWellLayerRow.waterVolume;
  for (const wellLayerIngredient of sourceWellLayerRow.wellLayerIngredientList) {
    const newTargetLayerIng: TargetLayerIngredient = new TargetLayerIngredient();
    copyWelllayerIngredients(newTargetLayerIng, wellLayerIngredient);
    targetWellLayerRow.targetLayerIngredientList.push(newTargetLayerIng);
  }

  return targetWellLayerRow;
}

function CopyWellDropLayer(lyr: DrawingLayer, sourceDropLayerRow: DropDTO) {
  const targetDropLayerRow: TargetLayer = new TargetLayer();
  targetDropLayerRow.layerId = lyr.id;
  targetDropLayerRow.volume = sourceDropLayerRow.volume;
  targetDropLayerRow.waterVolume = sourceDropLayerRow.waterVolume;
  targetDropLayerRow.sourceWellId = sourceDropLayerRow.wellId;
  targetDropLayerRow.layer = lyr;
  return targetDropLayerRow;
}
function GenerateLockedWellDropLayers(docData: ExperimentDtoClient, lyr: DrawingLayer) {
  let randomLayer: RandomLayerDTO;
  if (lyr.type != LayerType.Random) {
    return randomLayer;
  } else {
    randomLayer = lyr.layerDetail as RandomLayerDTO;
  }

  let listDropRows = cloneDeep(findWellDropsInLayer1d(docData.plateDto, lyr));
  listDropRows = listDropRows.sort((w1, w2) => w1.dropNumber - w2.dropNumber);
  unGenerateLayer(docData, lyr);
  let ableToGenerateAllWells = true;
  const wells = findWellsInLayer(
    docData.plateDto,
    lyr,
    docData.containerRows,
    docData.containerCols,
  );
  let count = 0;
  for (let i = 0; i < lyr.height + 1; i++) {
    for (let j = 0; j < lyr.width + 1; j++) {
      if (count >= listDropRows.length) {
        break;
      }
      let wellDropRow = getDrop(wells[i][j], lyr);
      wellDropRow = newDrop(wells[i][j], lyr);
      if (wellDropRow.dropNumber === listDropRows[count].dropNumber) {
        ableToGenerateAllWells = GenerateWellDropForLockedLayer(
          docData,
          lyr,
          wells[i][j],
          listDropRows[count],
        );
      }

      count++;
      if (!ableToGenerateAllWells) {
        return false;
      }
    }
  }
  return true;
}

function GenerateLockedLayer(docData: ExperimentDtoClient, lyr: DrawingLayer) {
  if (!CanPlatesBeGenerated(docData, lyr)) {
    return false;
  }

  if (lyr.targetDrop > 0) {
    return GenerateLockedWellDropLayers(docData, lyr);
  } else {
    return GenerateLockedWellLayers(docData, lyr);
  }
}
export function RandomLayerGenerate(
  docData: ExperimentDtoClient,
  lyr: DrawingLayer,
  // nonDirtyLyr: LayerDTO,
) {
  if (!lyr.locked) {
    Generate(docData, lyr);
  } else {
    GenerateLockedLayer(docData, lyr);
  }
}
export function GetRandomLayerGenerationList(
  randomLayer: RandomLayerDTO,
): RandomLayerGenerationListDTO[] {
  const randomLayerGenerationList: RandomLayerGenerationListDTO[] = [];
  randomLayer.randomLayerIngredientGroup.map((ig) => {
    ig.randomLayerGenerationList.map((gl) => randomLayerGenerationList.push(gl));
  });
  return randomLayerGenerationList;
}
export function GetGroups(randomLayer: RandomLayerDTO) {
  const groups: RandomLayerIngredientGroupDTO[] = [];

  // At least 1 group must be chosen.
  let groupGenerationAttempts = 0;
  while (groups.length == 0) {
    // Safety net.
    if (++groupGenerationAttempts > MAX_GROUP_GENERATION_ATTEMPTS) {
      //Unable to generate groups from generation list. Group probabilities are too low.
      return;
    }
    let randomLayerGenerationListItems: RandomLayerGenerationListDTO[] = [];

    if (randomLayer != null) {
      randomLayerGenerationListItems = GetRandomLayerGenerationList(randomLayer);
    }

    randomLayerGenerationListItems.forEach((generationListRow) => {
      if (Math.random() < generationListRow.probability) {
        const randomLayerIngredientGroupRow: RandomLayerIngredientGroupDTO =
          GetRandomLayerIngredientGroup(
            randomLayer,
            generationListRow.randomLayerIngredientGroupId,
          );
        if (randomLayerIngredientGroupRow != null) {
          //Ignore those groups that doesn't conatains ingredients.
          if (randomLayerIngredientGroupRow.randomLayerGroupIngredient.length > 0) {
            groups.push(randomLayerIngredientGroupRow);
          }
        }
      }
    });
  }
  return groups;
}
export function GetRandomLayerIngredientGroup(
  randomLayer: RandomLayerDTO,
  ingredientGroupId: number,
): RandomLayerIngredientGroupDTO {
  return randomLayer.randomLayerIngredientGroup.find((ig) => ig.id === ingredientGroupId);
}
export function GenerateWellLayerIngredients(
  randomLayer: RandomLayerDTO,
  well: WellIngDTO,
  wellIngredientsHash,
  lyr: DrawingLayer,
  docData: ExperimentDtoClient,
): boolean {
  let wellAttempts = 0;
  let targetLayer: TargetLayer;
  while (wellAttempts < MAX_WELL_INGREDIENT_GENERATION_ATTEMPTS) {
    let groups: RandomLayerIngredientGroupDTO[] = [];
    // Pick groups that will supply well ingredients.
    groups = GetGroups(randomLayer);
    if (!groups) {
      return null;
    }
    //   System.Windows.Forms.MessageBox.Show( null, plateException.Message, "Probalility Error", System.Windows.Forms.MessageBoxButtons.OK );
    // Loop through each group, choosing one random ingredient from each.
    const wellGroupIngredients: RandomLayerGroupIngredientDTO[] = GetWellGroupIngredients(
      randomLayer,
      groups,
    );

    // If we didn't find an ingredient from each group, scrap this well, start over.
    if (wellGroupIngredients.length != groups.length) {
      wellAttempts++;
      continue;
    }
    targetLayer = createTargetLayer(lyr, well);
    targetLayer.volume = randomLayer.wellVolume;
    targetLayer.waterVolume = 0;
    GenerateWellLayerIngredient(
      lyr,
      wellGroupIngredients,
      targetLayer,
      randomLayer.gridSteps,
    );

    // If this is a duplicate well, try again.
    if (IsDuplicateWell(targetLayer, lyr, wellIngredientsHash)) {
      for (const targetLayerIngredient of targetLayer.targetLayerIngredientList) {
        spliceArrayElement(targetLayer.targetLayerIngredientList, targetLayerIngredient);
      }
      wellAttempts++;
      continue;
    }
    Compute(targetLayer, lyr, docData);

    if (targetLayer.hasError) {
      for (const targetLayerIngredient of targetLayer.targetLayerIngredientList) {
        spliceArrayElement(targetLayer.targetLayerIngredientList, targetLayerIngredient);
      }
      wellAttempts++;
      continue;
    }

    if (lyr.targetDrop < 0) {
      updateWellByTargetLayer(lyr, targetLayer, well);
      well.wellWaterVolume += targetLayer.waterVolume;
    } else {
      const drop = updateDropByTargetLayer(lyr, targetLayer, well);
      drop.volume += targetLayer.volume;
      drop.waterVolume += targetLayer.waterVolume;
    }
    return true;
  }
  return false;
}
function IsDuplicateWell(
  targetLayer: TargetLayer,
  randomlayerRow: LayerDTO,
  wellIngridentsHash: string[],
) {
  //Using Hash Set to check duplicates
  const ing = GetWellIngredientsHash(targetLayer, randomlayerRow);
  const index = wellIngridentsHash.findIndex((i) => i === ing);
  if (index < 0 || wellIngridentsHash.length === 0) {
    wellIngridentsHash.push(ing);
    return false;
  }
  return true;
}
function GetWellIngredientsHash(targetLayer: TargetLayer, randomlayerRow: LayerDTO) {
  const sortedIngredientsHashList: any[] = [];
  if (!isNullOrUndefined(targetLayer)) {
    for (const wellLayerIngredientRow of targetLayer.targetLayerIngredientList) {
      const ingredientHash =
        '(' +
        wellLayerIngredientRow.preMixedConcentration +
        '_' +
        wellLayerIngredientRow.ingredientIngredientTypeId +
        '_' +
        wellLayerIngredientRow.ingredientStockId +
        (isNullOrUndefined(wellLayerIngredientRow.pH)
          ? ''
          : '_' + wellLayerIngredientRow.pH + ')');

      sortedIngredientsHashList.push(ingredientHash);
    }
  }
  let hashStringBuilder = '';
  for (const ingredientHash of sortedIngredientsHashList) {
    hashStringBuilder += ingredientHash;
  }

  return hashStringBuilder;
}
export function GenerateWellLayerIngredient(
  lyr: LayerDTO,
  wellGroupIngredients: RandomLayerGroupIngredientDTO[],
  targetLayer: TargetLayer,
  gridSteps: number,
) {
  // For each groupIngredient chosen, create a well ingredient row and
  // generate random values for its concentration and pH( for buffers ).
  if (lyr.targetDrop > 0) {
    targetLayer.targetLayerIngredientList = [];
    return;
  }
  for (const groupIngredient of wellGroupIngredients) {
    const targetLayerIngredient: TargetLayerIngredient =
      CreateTargetLayerIngredient(targetLayer);

    targetLayerIngredient.volume = targetLayerIngredient.concentration = 0;

    targetLayerIngredient.ingredientIngredientTypeId =
      groupIngredient.ingredientIngredientTypeId;
    targetLayerIngredient.ingredientStockIngredient = getIngredient(
      getIngStock(groupIngredient.ingredientStockId).ingredientId,
    );
    targetLayerIngredient.color = getIngredientColor(
      groupIngredient.ingredientIngredientTypeId,
    );
    targetLayerIngredient.lowPHVolume = groupIngredient.lowPh;

    targetLayerIngredient.highPHVolume = groupIngredient.highPh;
    // targetLayerIngredient.concentration = groupIngredient.highConcentration
    //--Todo - Need to verify hex color converter
    targetLayerIngredient.hexColor =
      '#' + targetLayerIngredient.color.toString(16).padStart(6, '0').toUpperCase();
    const ingIngType = getIngIngType(groupIngredient.ingredientIngredientTypeId);
    targetLayerIngredient.ingredientTypeId = ingIngType.ingredientTypeId;
    const ingType = getIngredientType(ingIngType.ingredientTypeId);
    const ingColor = getIngredientTypeColor(ingType.ingredientTypeColorId);
    targetLayerIngredient.ingredientTypeColorGroupId = ingColor.groupId;
    targetLayerIngredient.ingredientTypeName = ingType.name;

    targetLayerIngredient.isBuffer = IsBuffer(groupIngredient.ingredientIngredientTypeId);
    targetLayerIngredient.ingredientTypeIsBuffer = targetLayerIngredient.isBuffer;
    targetLayerIngredient.ingredientIngredientTypeIsBuffer = false;

    targetLayerIngredient.ingredientStockId = groupIngredient.ingredientStockId;
    targetLayerIngredient.ingredientStock = getIngStock(
      groupIngredient.ingredientStockId,
    );
    targetLayerIngredient.ingredientStockId = groupIngredient.ingredientStockId;

    if (!isNullOrUndefined(groupIngredient.highPhingredientStockId)) {
      targetLayerIngredient.highPhIngStockId = groupIngredient.highPhingredientStockId;
    } else {
      targetLayerIngredient.highPhIngStockId = null;
    }

    // generate random values for concentration and pH.
    const concGridLine: GridLine = new GridLine(
      groupIngredient.lowConcentration,
      groupIngredient.highConcentration,
      gridSteps,
    );
    targetLayerIngredient.preMixedConcentration = concGridLine.GetRandomStep();
    if (ingType.isBuffer) {
      const phGridLine: GridLine = new GridLine(
        groupIngredient.lowPh,
        groupIngredient.highPh,
        gridSteps,
      );
      targetLayerIngredient.pH = phGridLine.GetRandomStep();
    }
  }
}
function DoesIngredientConflict(
  wellIngredients: RandomLayerGroupIngredientDTO[],
  testIngredientRow: RandomLayerGroupIngredientDTO,
  randomLayerExcludeList: RandomLayerExcludeListDTO[],
): boolean {
  // Check to see if well already contains the ingredient.
  for (const groupIngredientRow of wellIngredients) {
    if (
      getIngredientStock(testIngredientRow.ingredientStockId).ingredientId ==
      getIngredientStock(groupIngredientRow.ingredientStockId).ingredientId
    ) {
      return true;
    }
  }
  // For each exclusion in exclude list for this experiment
  const stock = getIngredientStock(testIngredientRow.ingredientStockId);
  if (isNullOrUndefined(stock)) {
    return false;
  }
  const testIngredientID = stock.ingredientId;
  for (const excludeListRow of randomLayerExcludeList) {
    let excludeIngredientID = -1;
    if (excludeListRow.ingredient1Id == testIngredientID) {
      excludeIngredientID = excludeListRow.ingredient2Id;
    } else if (excludeListRow.ingredient2Id == testIngredientID) {
      excludeIngredientID = excludeListRow.ingredient1Id;
    } else {
      // No match.
      continue;
    }

    // There is an exclusion involving the ingredient to test.
    // Search the list of wellIngredients to see if there is a match.
    for (const groupIngredientRow of wellIngredients) {
      if (
        getIngredientStock(groupIngredientRow.ingredientStockId).ingredientId ==
        excludeIngredientID
      ) {
        return true;
      }
    }
  }

  // No exclusion found.
  return false;
}
export function GetWellGroupIngredients(
  randomLayer: RandomLayerDTO,
  groups: RandomLayerIngredientGroupDTO[],
): RandomLayerGroupIngredientDTO[] {
  // Loop through each group, choosing one random ingredient from each.
  const wellGroupIngredients: RandomLayerGroupIngredientDTO[] = [];
  for (const groupRow of groups) {
    let foundIngredient = false;
    const randomIngredientPicker: RandomIngredientPicker = new RandomIngredientPicker(
      groupRow,
    );
    while (!foundIngredient && randomIngredientPicker.GetIngredient().length > 0) {
      // Pick a random ingredient from the group.
      const ingredientRow: RandomLayerGroupIngredientDTO =
        randomIngredientPicker.RandomIngredient();
      /*
       *
       *
       *  IngredientConflict yet to be implemented
       */
      // If the ingredient conflicts with another already in the well, remove it from the list of ingredients
      // to choose from.
      if (
        DoesIngredientConflict(
          wellGroupIngredients,
          ingredientRow,
          randomLayer.randomLayerExcludeList,
        )
      ) {
        randomIngredientPicker.RemoveIngredient(ingredientRow);
      } else {
        // Add ingredient to the list of well ingredients.
        wellGroupIngredients.push(ingredientRow);
        foundIngredient = true;
      }
    }

    // Couldn't find an ingredient from this group. Abort ingredient generation for this well.
    if (!foundIngredient) {
      break;
    }
  }
  return wellGroupIngredients;
}

export function CanPlatesBeGenerated(docData: ExperimentDtoClient, lyr: DrawingLayer) {
  // Plates can't be generated if:

  // If no ingredients have been added to the experiment.
  if (!RandomLayerGroupIngredient.CanPlatesBeGenerated(lyr)) {
    return false;
  }

  // If generation list is empty
  if (!RandomLayerGenerationList.CanPlatesBeGenerated(lyr)) {
    return false;
  }

  if (!RandomExcludeList.CanPlatesBeGenerated(lyr)) {
    return false;
  }

  return true;
}

export async function createNewRandomLayer(
  docData: ExperimentDtoClient,
  target: number,
): Promise<DrawingLayer> {
  if (docData.layers === undefined) {
    docData.layers = [];
  }

  let layerVolume = docData.defWellVolume;
  if (target > 0) {
    layerVolume = docData.containerDefAdditiveVolume;
  }

  const baseLayerName = 'Random Layer';
  const layerName = await getUniqueLayerName(docData.layers, baseLayerName);
  const newLayer = new DrawingLayer();
  newLayer.layerDetail = new RandomLayerDTO();
  newLayer.name = layerName;
  newLayer.expId = docData.expId;
  newLayer.volume = layerVolume;
  newLayer.targetDrop = target;
  newLayer.x = 0;
  newLayer.y = 0;
  newLayer.width = docData.containerCols - 1;
  newLayer.height = docData.containerRows - 1;
  newLayer.type = LayerType.ConditionList;
  newLayer.startingWellNumber = 1;
  newLayer.volumeBasedAddition = true;
  newLayer.dispenseManually = false;
  newLayer.locked = false;

  docData.layers.push(newLayer);
  return newLayer;
}
